<template>
  <div class="container">
    <el-tag
      v-for="tag in tags"
      :key="tag"
      type="info"
      class="tag"
      :effect="readonly ? 'plain' : 'light'"
      :closable="!readonly"
      @close="handleClose(tag)"
      >{{ tag }}</el-tag
    >
    <el-input
      v-if="editing"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      class="tag input"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    />
    <el-button v-else-if="!readonly" size="small" class="tag" @click="handleAdd"
      >+ 添加</el-button
    >
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      inputValue: '',
      editing: false,
    };
  },
  computed: {
    tags() {
      const tags = this.value.split(',');
      if (tags.length === 1 && tags[0] === '') return [];
      return tags;
    },
  },
  methods: {
    handleAdd() {
      this.editing = true;
      this.inputValue = '';
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.setValue(this.tags.filter((item) => item !== tag));
    },
    handleInputConfirm() {
      if (this.inputValue && !this.tags.includes(this.inputValue))
        this.setValue([...this.tags, this.inputValue]);
      this.editing = false;
      this.inputValue = '';
    },
    setValue(value) {
      // this.value = value.join(',');
      this.$emit('input', value.join(','));
    },
  },
};
</script>

<style scoped>
.container {
  text-align: left;
}
.tag + .tag {
  margin-left: 8px;
}
.input {
  width: 120px;
}
</style>
